<template>
  <div class="relative w-full">
    <RevRadio
      :id
      :class="[
        $style.radio,
        {
          [$style.blueHighlighted]: isHighlighted,
        },
      ]"
      :model-value="isSelected"
      :tagProps
      :value="id"
      variant="full"
      @click="handleClick"
    >
      <template #label>
        <span class="body-1-bold">{{ offer.title }}</span>

        <template v-if="offer.price && offer.price.amount !== '0.00'">
          <InsurancePrice :is-monthly="offer.isMonthly" :price="offer.price" />
        </template>
      </template>
      <template #description>
        <ul class="mt-8 space-y-8">
          <li
            v-for="benefit in offer.benefits.short"
            :key="benefit"
            class="flex items-center"
          >
            <IconCheckSmall class="shrink-0 self-start" /> {{ benefit }}
          </li>
        </ul>
      </template>
    </RevRadio>
  </div>
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevRadio } from '@ds/components/Radio'
import { VariantsEnum } from '@ds/components/Tag/Tag.constant'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import InsurancePrice from './components/InsurancePrice/InsurancePrice.vue'

const { trackClick } = useTracking()

const props = defineProps<{
  id: string
  offer: InsuranceOffer
  isSelected: boolean
  isHighlighted: boolean
  trackingZone: string
  tagProps: { label: string; variant: VariantsEnum } | undefined
}>()

const emit = defineEmits(['select', 'remove'])

function handleClick() {
  trackClick({
    name: props.offer.title,
    value: props.offer.isMonthly ? 'monthly' : 'upfront',
    zone: props.trackingZone,
  })

  emit(props.isSelected ? 'remove' : 'select')
}
</script>

<style lang="css" module>
.radio {
  @apply h-full;
}

.radio > label {
  @apply h-full;
  @apply border-l-6;
  @apply border-l-static-default-mid;
}

.radio.blueHighlighted > label {
  @apply border-l-action-brand-hi;
}
</style>
